// extracted by mini-css-extract-plugin
export default {"Textbox":"BiKB4CKZ","TextboxPlaceholder":"YB7c6MAv","PlaceholderContent":"bTkpSoo1"};